import ResponseBase from "../domain/endpoint/ResponseBase";
import {ResponseStatusCodeConstants} from "../domain/endpoint/ResponseStatusCodeConstants";
import {PollerRetryState} from "../domain/poller/PollerPayload";
import PollerValidatorReply from "../domain/poller/PollerValidatorReply";

export default class PollControllerBase {
    public static resolveIfSuccess(data: ResponseBase, resolve: any) {
        let resolved = false;
        if (data && data.statusCode && data.statusCode === ResponseStatusCodeConstants.SUCCESS) {
            resolve(new PollerValidatorReply(PollerRetryState.RESOLVE_WITH_DATA, data));
            resolved = true;
        }
        return resolved;
    }

    public static resolveIfRetryState(data: ResponseBase, resolve: any) {
        let resolved = false;
        if (data && data.statusCode && (
            data.statusCode === ResponseStatusCodeConstants.RETRY_REQUEST ||
            data.statusCode === ResponseStatusCodeConstants.DATA_NOT_READY ||
            data.statusCode === ResponseStatusCodeConstants.NOT_ENQUEUED)) {
            resolve(new PollerValidatorReply(PollerRetryState.RETRY, data));
            resolved = true;
        }
        return resolved;
    }

    public static validator(data: ResponseBase) {

        return new Promise((resolve) => {

            if (PollControllerBase.resolveIfSuccess(data, resolve)) {
                return;
            }

            if ( PollControllerBase.resolveIfRetryState(data, resolve) ) {
                return;
            }

            resolve(new PollerValidatorReply(PollerRetryState.REJECT_WITH_DATA, data));
        });
    }
}
